import { Col, Row, Table, Tag } from "antd";
import Column from "antd/es/table/Column";
import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { Links } from "../../helpers/Links";
import { dateCommon } from "../../helpers/common";
import { HopDongHetHan } from "../../models/hopdong/HopDong";
import { layHopDongHetHan } from "../../services/hopdong";
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

const CanhBaoHetHan = () => {
    const dispatch = useDispatch();
    const [dsHdHetHan, setDsHdHetHan] = useState<Array<HopDongHetHan>>([]);

    const layHdHetHan = async () => {
        try {
            dispatch(showLoadingScreen());
            var data = await layHopDongHetHan();
            setDsHdHetHan(data);
            dispatch(hideLoadingScreen());
        }
        catch (err: any) {
            toast.error(err);
            dispatch(hideLoadingScreen());
        };
    }

    useEffect(() => {
        layHdHetHan();
    }, []);

    return (<section>
        <ContentHeader title="Cảnh báo hết hạn" />
        <div className="card card-primary">
            <Row>
                <Col span={24}>
                    <Table
                        locale={{ emptyText: "Không có dữ liệu" }}
                        dataSource={dsHdHetHan.map((value, index) => { const item = { key: index, ...value }; return item; })}
                    >
                        <Column title="Số quyết định" dataIndex="soQuyetDinh" key="soQuyetDinh" />
                        <Column title="Loại hết hạn" key="loai" render={(value: HopDongHetHan, record, index) =>
                        (
                            <>
                                {value.loai == "1" ? "Hợp đồng/QĐ bổ nhiệm" : "Quyết định bậc lương"}
                            </>
                        )
                        } />

                        <Column title="Nhân sự"
                            key="hoTen"
                            render={(value: HopDongHetHan, record, index) =>
                            (
                                <>
                                    {value.hoTen}
                                </>
                            )
                            }
                        />
                        <Column title="Phòng ban"
                            key="donVi"
                            render={(value: HopDongHetHan, record, index) =>
                            (
                                <>
                                    {value.tenDonVi}
                                </>
                            )
                            }
                        />
                        <Column title="Ngày bắt đầu"
                            key="ngayBatDau"
                            render={(value: HopDongHetHan, record, index) =>
                            (
                                <>
                                    {dateCommon.formatDate(value.ngayBatDau)}
                                </>
                            )
                            }
                        />
                        <Column title="Ngày kết thúc"
                            key="ngayBatDau"
                            render={(value: HopDongHetHan, record, index) =>
                            (
                                <>
                                    {dateCommon.formatDate(value.ngayKetThuc)}
                                </>
                            )
                            }
                        />
                        <Column title="Loại hợp đồng/QĐ bổ nhiệm" dataIndex="loaiHopDong" key="loaiHopDong" />
                        <Column title="Trạng thái"
                            key="trangThai"
                            render={(value: HopDongHetHan, record, index) =>
                            (
                                value.thoiHan < 0 ?
                                    <Tag color="red">Quá hạn ({Math.abs(value.thoiHan)} ngày)</Tag>
                                    :
                                    <Tag color="gold">Sắp hết hạn ({Math.abs(value.thoiHan)} ngày)</Tag>
                            )
                            }
                        />
                        <Column
                            title="Hợp đồng điện tử"
                            key="hddt"
                            render={(value: HopDongHetHan, record, index) =>
                            (record.loai == "1" ? record.idHopDongDienTu > 0 ?
                             <Link key={"link" + index} title="Xem hợp đồng điện tử" className="hrm-btn hrm-btn-sm  btn-success" to={`${Links.HopDong.ChiTietHopDongDienTu}?id=${value?.idHopDongDienTu}`}>Xem</Link>:
                                <Link key={"link" + index} title="Thiết lập hợp đồng điện tử" className="hrm-btn hrm-btn-sm  hrm-btn-warning"  to={`${Links.HopDong.ChiTietHopDongDienTu}?idNhanVien=${value?.idNhanVien}&idHopDongCu=${value?.id}`}>Thiết lập</Link>
                                : null
                            )
                            }
                        />
                        <Column
                            title=""
                            key="action"
                            render={(value: HopDongHetHan, record, index) =>
                            (
                                <Link key={"link" + index} className="hrm-btn hrm-btn-sm  btn-primary" title="Xem hợp đồng" to={`${Links.HopDong.Xem}?id=${value?.idNhanVien}`}>Xem</Link>
                            )
                            }
                        />
                    </Table>
                </Col>
            </Row>
        </div>
    </section>
    )
}

export default CanhBaoHetHan;